import { postMultiDayShifts } from './PostMultiDayShifts';
import { inviteProfessionalsToJobs } from './InviteProfessionalsToJobs';

export const MultiDayShiftsClient = {
  postMultiDayShifts,
  inviteProfessionalsToJobs,
};
